import * as React from 'react'
import { Helmet } from 'react-helmet'
import { graphql, useStaticQuery } from 'gatsby'
import { useLocation } from '@reach/router'

export function Seo({
  title = '',
  description = '',
  pathname = '',
  image = '',
  search = '',
  children = null,
}) {
  const location = useLocation()
  const {
    site: { siteMetadata },
  } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          siteTitle
          siteTitleDefault
          siteUrl
          hrefLang
          siteDescription
          siteImage
        }
      }
    }
  `)

  const {
    siteTitle,
    siteTitleDefault,
    siteUrl,
    siteDescription,
    siteImage,
    hrefLang,
    twitter,
  } = siteMetadata

  const seo = {
    title:
      `${title} | ${siteTitleDefault} ${search ? '| ' + search : ''}` ||
      siteTitleDefault,
    description: description || siteDescription,
    url: pathname ? `${siteUrl}/${pathname}` : location.href,
    image: `https:${image || siteImage}`,
  }

  return (
    <Helmet
      title={title}
      defaultTitle={siteTitleDefault}
      titleTemplate={`%s | ${siteTitle} ${search ? '| ' + search : ''}`}
    >
      <html lang={hrefLang} />
      <meta name='description' content={seo.description} />
      <meta name='image' content={seo.image} />
      <meta property='og:title' content={seo.title} />
      <meta property='og:url' content={seo.url} />
      <meta property='og:description' content={seo.description} />
      <meta property='og:image' content={seo.image} />
      <meta property='og:type' content='website' />
      <meta name='twitter:card' content='summary_large_image' />
      <meta name='twitter:title' content={seo.title} />
      <meta name='twitter:url' content={seo.url} />
      <meta name='twitter:description' content={seo.description} />
      <meta name='twitter:image' content={seo.image} />
      <meta name='twitter:creator' content={twitter} />
      <link
        rel='icon'
        type='image/png'
        sizes='32x32'
        href='/favicon-32x32.png'
      />
      <link
        rel='icon'
        type='image/png'
        sizes='16x16'
        href='/favicon-16x16.png'
      />
      <link
        rel='apple-touch-icon'
        sizes='180x180'
        href='/apple-touch-icon.png'
      />
      {/* The following meta tag is for demonstration only and can be removed */}
      {!!process.env.GATSBY_DEMO_STORE && (
        <meta name='robots' content='noindex, nofollow' />
      )}
      {children}
      {/* <script>{`var $wc_load=function(a){return JSON.parse(JSON.stringify(a))},$wc_leads=$wc_leads||{doc:{url:$wc_load(document.URL),ref:$wc_load(document.referrer),search:$wc_load(location.search),hash:$wc_load(location.hash)}};`}</script>
      <script src='//s.ksrndkehqnwntyxlhgto.com/128568.js'></script> */}

      <script type='text/javascript'>
        {`
          var script = document.createElement('script');
          script.async = true; script.type = 'text/javascript';
          var target = 'https://www.clickcease.com/monitor/stat.js';
          script.src = target;var elem = document.head;elem.appendChild(script);
        `}
      </script>

      {/* <script src='https://s.ksrndkehqnwntyxlhgto.com/128568.js'></script> */}

      <script type='text/javascript'>
        {`
          var script = document.createElement('script');
          script.async = true; script.type = 'text/javascript';
          var target = 'https://www.clickcease.com/monitor/stat.js';
          script.src = target;var elem = document.head;elem.appendChild(script);
        `}
      </script>

      <noscript>
        {`
          <a href='https://www.clickcease.com' rel='nofollow'>
            <img src='https://monitor.clickcease.com' alt='ClickCease' />
          </a>
        `}
      </noscript>
    </Helmet>
  )
}
